exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pay-popup-img[data-v-1f8215cd]{display:block;line-height:0px}.pay-popup-img .upload-inner__box[data-v-1f8215cd]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.pay-popup-img .pay-popup-img-icon[data-v-1f8215cd]{margin-right:10px;border:1px dashed #d9d9d9;border-radius:6px;font-size:28px;color:#8c939d;width:100px;height:100px;line-height:100px;text-align:center}", ""]);

// exports
